import React, { FC } from 'react';
import { Tooltip } from '@b-design/fusion';
import $i18n from '../../../../../../i18n';
import './index.less';

interface PropsType {
  record: any;
}

const FlowDrawerHeader: FC<PropsType> = ({ record }) => {
  return (
    <div className="flow-drawer-header-info">
      <div className="name">
        <Tooltip trigger={<span className='name-ellipsis'>{record.name || ''}</span>}>{record.name || ''}</Tooltip>
        {record.alias ? <Tooltip trigger={<span className='name-alias'>&nbsp;(<span className='name-ellipsis'>{record.alias}</span>)</span>}>{record.alias || ''}</Tooltip> : null}
      </div>
      <div className="right">
        <div className="id">ID: {record.identify || ''}</div>
        {record?.isCustom === '1' && (
          <div className="tag">
            {$i18n.get({ id: 'aopf.component.flowDrawerHeader.Customization', dm: '定制' })}
          </div>
        )}
      </div>
    </div>
  );
};

export default FlowDrawerHeader;
